import { InjectionToken } from "@angular/core";
import type { AgentIdleState } from "../../model/agent.types";

export const CHAT_IDLE_DEFAULTS: Required<AgentIdleState> = {
  icon: "smart_toy",
  title: "How can I help you?",
  subtitle: "Ask about imagery, parcels, or data pipelines.",
  suggestions: [],
  layout: "compact",
};

/** Provided by ChatContainerComponent; consumed by ChatIdleStateComponent. */
export const CHAT_IDLE_CONFIG = new InjectionToken<AgentIdleState>("CHAT_IDLE_CONFIG");
